import { THEMES, THEME_LABELS, useTheme } from '../shared/theme.ts';
import styles from './ThemePicker.module.css';

/**
 * Three named looks rather than a light/dark toggle, because obsidian is not a
 * lighter or darker version of anything -- it is a different intent.
 */
export function ThemePicker(): React.JSX.Element {
  const [theme, setTheme] = useTheme();

  return (
    <div className={styles.group} role="group" aria-label="Theme">
      {THEMES.map((option) => (
        <button
          key={option}
          type="button"
          className={styles.option}
          aria-pressed={theme === option}
          onClick={() => setTheme(option)}
        >
          {THEME_LABELS[option]}
        </button>
      ))}
    </div>
  );
}
